import type { Control } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import type { ExportButtonFieldProps } from './export-button-field.component';
import ExportButtonField from './export-button-field.component';

interface HfExportButtonFieldProps extends ExportButtonFieldProps {
  control?: Control;
  name?: string;
}

function HfExportButtonField({
  id,
  name = 'export_button',
  control,
  buttonCaption,
  fieldType,
  recordId,
  readOnly,
}: HfExportButtonFieldProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={() => (
        <ExportButtonField
          id={id}
          buttonCaption={buttonCaption}
          fieldType={fieldType}
          recordId={recordId}
          readOnly={readOnly}
        />
      )}
    />
  );
}

export default HfExportButtonField;
